import React from 'react'
import { BiRightArrowAlt } from 'react-icons/bi'
import userImg from '../../assets/account.svg'

const PlayerRanking = ({ data, maxHeight }) => {
  return (
    <div className='player_ranking_box'>
      <header>
        <h3>Player Ranking (Top 200)</h3>
        <p>
          View All <BiRightArrowAlt size={18} />
        </p>
      </header>
      <section
        className='player_ranking_body'
        style={{ maxHeight: maxHeight ? maxHeight : '516px' }}
      >
        {data?.map((v, i) => {
          return (
            <div
              key={i}
              className='card_box'
              style={{ backgroundColor: v?.teamId?.teamColor || 'var(--primaryPurple)' }}
            >
              <div
                className='team_image_box'
                style={{ backgroundImage: `url(${v?.teamId?.logo})` }}
              />

              <h3>
                {v?.player_id?.FirstName} <b>{v?.player_id?.LastName}</b>
              </h3>
              <div className='image_box'>
                <img src={v?.player_id?.HostedHeadshotNoBackgroundUrl || userImg} />
              </div>
              <div className='player_score_box'>
                <p>{v?.playerScore}</p>
              </div>
            </div>
          )
        })}
      </section>
    </div>
  )
}

export default PlayerRanking
